import type { Space } from "@/types"
import type { RBACFlag } from "@/types/rbac"

export const Roles = {
  "role:edu-admin": "role:edu-admin",
  "role:edu-teacher": "role:edu-teacher",
  "role:edu-student": "role:edu-student",
  "role:pro-admin": "role:pro-admin",
  "role:pro-editor": "role:pro-editor",
  "role:pro-service": "role:pro-service",
  "role:pro-viewer": "role:pro-viewer"
} as const

export const RolesMap: Record<
  Space["space"],
  Array<{
    value: keyof typeof Roles
    label: string
  }>
> = {
  edu: [
    { value: Roles["role:edu-admin"], label: "Admin" },
    { value: Roles["role:edu-teacher"], label: "Teacher" },
    { value: Roles["role:edu-student"], label: "Student" }
  ],
  pro: [
    { value: Roles["role:pro-admin"], label: "Admin" },
    { value: Roles["role:pro-editor"], label: "Editor" },
    { value: Roles["role:pro-service"], label: "Service" },
    { value: Roles["role:pro-viewer"], label: "Viewer" }
  ],
  private: []
}

/**
 * The RBAC flag granting permission to **invite** a member with each role. Not every role can add
 * every other role (e.g. a pro Editor can only add Service members), so member-management UI must
 * check `can(RoleAddFlag[targetRole])` per target role rather than a blanket "is admin" check.
 */
export const RoleAddFlag: Record<keyof typeof Roles, RBACFlag> = {
  "role:edu-admin": "edu-admin::add",
  "role:edu-teacher": "edu-teacher::add",
  "role:edu-student": "edu-student::add",
  "role:pro-admin": "pro-admin::add",
  "role:pro-editor": "pro-editor::add",
  "role:pro-service": "pro-service::add",
  "role:pro-viewer": "pro-viewer::add"
}

/** The RBAC flag granting permission to **change** the role of a member who currently holds each role. */
export const RoleChangeFlag: Record<keyof typeof Roles, RBACFlag> = {
  "role:edu-admin": "edu-admin::change-role",
  "role:edu-teacher": "edu-teacher::change-role",
  "role:edu-student": "edu-student::change-role",
  "role:pro-admin": "pro-admin::change-role",
  "role:pro-editor": "pro-editor::change-role",
  "role:pro-service": "pro-service::change-role",
  "role:pro-viewer": "pro-viewer::change-role"
}
